import { Bar } from 'react-chartjs-2';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { CircularProgress } from '@chakra-ui/react';

export const UsageByStoreGraph = ({ highestUsageData, height }: { highestUsageData?: any; height: string }) => {
  const { colors } = useTheme();

  if (!highestUsageData) return <CircularProgress isIndeterminate />;

  return (
    <Bar
      options={{
        indexAxis: 'y' as const,
      }}
      height={height}
      data={{
        labels: highestUsageData.map((h: any) => h.discountCompanyName),
        datasets: [
          {
            label: 'Utilizações',
            data: highestUsageData.map((h: any) => h.discountCount),
            backgroundColor: colors.graphColors,
          },
        ],
      }}
    />
  );
};
